import { Outlet } from "react-router-dom";
import { Col, Container, Row, ButtonGroup, Dropdown } from "react-bootstrap";
import { useAuth } from "../../utils/auth";
import { useTranslation } from "react-i18next";

import { updateLanguageAPI } from "../../features/auth/api/authAPI";

export default function MainLayout() {
    const { logout } = useAuth();
    const { i18n } = useTranslation();

    const username = localStorage.getItem('username');
    const isLoggedIn = Boolean(localStorage.getItem('token'));

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        updateLanguageAPI(lng);
    };
    
    const handleLogout = () => {
        logout();
    };

    return (
        <Container fluid className="container-sm container-md container-lg" style={{
            height: "100vh", padding: "0"}}>
            <Row className="d-flex flex-wrap" style={{ margin: "0" }}>
                <Col xs={6} md={6} className="d-flex align-items-center" style={{ padding: "0" }}>
                    <img
                        src="/logo-craiteria.svg"
                        alt="Craiteria"
                        style={{ width: '150px' }}
                    />
                </Col>
                {isLoggedIn && (
                    <Col xs={4} md={4} className="justify-content-end" style={{ padding: "0" }}>
                        <div className="usuari"> {username} </div>
                    </Col>
                )}
                <Col xs={2} md={2} className="justify-content-end" style={{ padding: "0" }} >
                    <Dropdown as={ButtonGroup}>
                        <Dropdown.Toggle className="border-0" split id="dropdown-split-basic" style={{ background: "#ffffff" }} >
                            <img
                                src="/user.svg"
                                alt="Language"
                                style={{ width: '30px', }} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ minWidth: "auto", width: "100px", padding: "0" }}>
                            {isLoggedIn && (
                                <Dropdown.Item onClick={handleLogout} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }} className="btn btn-logout" >Logout</Dropdown.Item>
                            )}
                            <Dropdown.Item onClick={() => changeLanguage("ca")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>CA</Dropdown.Item>
                            <Dropdown.Item onClick={() => changeLanguage("en")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>EN</Dropdown.Item>
                            <Dropdown.Item onClick={() => changeLanguage("es")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>ES</Dropdown.Item>
                            <Dropdown.Item onClick={() => changeLanguage("fr")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>FR</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
            <Outlet />
            <Row className="justify-content-between py-5" id="footer">
                <Col>
                    <p>© 2024 - CraiterIA  - <a href="/Claims/TermsOfService">Terms of Service</a></p>
                </Col>
            </Row>
        </Container>
    );
}
